import { ROUTE_PATH } from "@/common/constants/routing";
import { AccessoryDto, AccessoryReferenceDto, AppPermission } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import AccessoryInline, { AccessoryInlineProps } from "./AccessoryInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity?: AccessoryDto | AccessoryReferenceDto;
  entityId?: string | null;
  inlineProps?: Partial<AccessoryInlineProps>;
}

export default function AccessoryLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.AccessoryRead]}
      to={ROUTE_PATH.ACCESSORY_VIEW(entity?.id || entityId || "")}
      content={
        <AccessoryInline entity={entity} entityId={entityId} {...inlineProps} withTooltip={false} />
      }
      {...otherProps}
    />
  );
}
